module.exports = __webpack_public_path__ + "static/problem-Solution-fit-48c2eed0ebbb75bf2405972241b15642.png";